import React from "react";
import moment from 'moment';
import * as twix from 'twix'; // Don't remove
import business from 'moment-business';
import {
    makeStyles,
    withStyles,
    Grid,
    Typography,
    TextField,
    Collapse,
    responsiveFontSizes,
    MuiThemeProvider,
    FormControl,
    InputLabel,
    MenuItem,
    Button,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    ListItemSecondaryAction,
    IconButton,
    Divider,
    Hidden,
} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { isBrowser } from "react-device-detect";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import LinearProgress from '@material-ui/core/LinearProgress';
import { ValidatorForm } from 'react-material-ui-form-validator';
import TextFieldValidator from "../Validator/TextFieldValidator";
import SelectValidator from "../Validator/SelectValidator";
import DatePickerValidator from "../Validator/DatePickerValidator";
import DropzoneAreaValidator from "../Validator/DropzoneAreaValidator";
import TimePickerValidator from "../Validator/TimePickerValidator";
import Review from './Review'
import WithDrawConfirm from './WithDrawConfirm'
import customAxios from "../../../API/customAxios";
import CircularProgress from '@material-ui/core/CircularProgress';
import { FormattedMessage, useIntl } from 'react-intl';
import ConfirmationBox from './ConfirmationBox'
import '../../../CSS/Calendar.css';
import { mobileTheme, pxToRem, breakpoints } from "../../../UIComponent/CommonStyle";
import { toNativeDate, rangeToDayConverter, getDifferenceInDate, minimumUntilDate, checkIsNewCompLeave, checkTimeOverlap } from '../../../Function/globalFunction';
import * as LeaveTypes from "../../../shared/Constant/LeaveTypes";
import ConfirmBox from "../../../UIComponent/ConfirmBox";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const thisTheme = responsiveFontSizes(mobileTheme);

const useStyles = disabled => makeStyles((theme) => ({
    remark: {
        color: '#856404',
        backgroundColor: '#fff3cd',
        boxShadow: 'none'
    },
    disabled: {
        color: '#000'
    },
    layout: {
        width: 'auto',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    datePicker: {
        width: '100%'
    },
    datePickerInput: {
        textAlign: 'left',
        padding: '1rem 1rem',
        fontSize: pxToRem(14),
        border: '1px solid #B8B8B8',
        borderRadius: 5,
        outline: 'none',
        height: pxToRem(50),
        minWidth: '100%',
        color: !disabled ? 'color' : '#000',
        [breakpoints.up("md")]: {
            fontSize: pxToRem(16),
            height: pxToRem(61),
        }
    },
    datePickerCalendar: {
        border: '1px solid #B8B8B8',
        fontSize: 8,
        [breakpoints.up("md")]: {
            fontSize: 10,
        }
    },
    dropzoneDiv: {
        marginTop: theme.spacing(1),
    },
    dropzone: {
        minHeight: '150px'
    },
    dropzoneParagraphClass: {
        padding: '1rem 1rem',
        fontSize: pxToRem(14),
        [breakpoints.up("md")]: {
            fontSize: pxToRem(16),
        }
    },
    editFile: {
        borderStyle: 'solid',
        border: '1px solid rgba(0, 0, 0, 0.12)',
        borderRadius: '5px'
    },
    submitButtonDiv: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: theme.spacing(1),
    },
    circularProgress: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(1),
    }
}));

const BorderLinearProgress = withStyles((theme) => ({
    root: {
        height: 20,
        borderRadius: 5,
        marginTop: theme.spacing(3),
    },
    colorPrimary: {
        backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
    },
    bar: {
        borderRadius: 5,
        backgroundColor: '#1A90FF',
    },
}))(LinearProgress);

const StyledDivider = withStyles({
    root: {
        background: '#DCDCDC',
        height: 2,
    },
})(Divider);

// UI init
let progressValue = 0;
let calculatorSpace;
let timePlaceholder;
let isOfficeStaff;

if (isBrowser === true) {
    calculatorSpace = 10;
} else {
    calculatorSpace = 1;
}

// Allowance variable
let taken = '';
let ifApproved = '';

// Approve mode usage
let action = '';

export default function LeaveForm({
    mode,
    employeeId,
    employeeName,
    staffDuty,
    annualTotal,
    editApplicationId,
    editTypeId,
    editTypeName,
    editStartDate,
    editStartTime,
    editUntilDate,
    editEndTime,
    editReason,
    editAttachment,
    editAttachmentPath,
    editStatus,
    editIsApprover,
    editUpdatedAt,
    approveId,
    approveMode,
    backToTable,
    compLeaveRows,
    isNewCompLeave,
    tabIndex,
    pageClose,
}) {
    const form = React.useRef();
    const intl = useIntl();
    const [types, setTypes] = React.useState([]);
    const [typeName, setTypeName] = React.useState('');
    const [defaultType, setDefaultType] = React.useState({
        id: '',
        type: '',
    });
    const [showFileUploaded, setShowFileUploaded] = React.useState(false);
    const [uploadedFileName, setUploadedFileName] = React.useState('');
    const [disabled, setDisabled] = React.useState(true);
    const [mlReadOnly, setMlReadOnly] = React.useState(false);
    const classes = useStyles(disabled)();
    const [formTitle, setFormTitle] = React.useState('');
    const [submitButtonText, setSubmitButtonText] = React.useState('Submit');
    const [submitButton, setSubmitButton] = React.useState(true);
    const [withDrawnButton, setWithDrawnButton] = React.useState(false);
    const [cancelButton, setCancelButton] = React.useState(false);
    const [approveButton, setApproveButton] = React.useState(true);
    const [dateTime, setDateTime] = React.useState([]);
    const [showCalculator, setShowCalculator] = React.useState(true);
    const [showDropzone, setShowDropzone] = React.useState(false);
    const [showDropzoneValidator, setShowDropzoneValidator] = React.useState(false);
    const [showReasonValidator, setShowReasonValidator] = React.useState(false);
    const [totalBalance, setTotalBalance] = React.useState();
    const [holiday, setHoliday] = React.useState();
    const [unformattedHoliday, setUnformattedHoliday] = React.useState();
    const [showAlert, setShowAlert] = React.useState();
    const [showWarning, setShowWarning] = React.useState(false);
    const [sickWarningMessage, setShowSickWarningMessage] = React.useState(false);
    const [shiftWarningMessage, setShowShiftWarningMessage] = React.useState();
    const [open, setOpen] = React.useState(false);
    const [approveOpen, setApproveOpen] = React.useState(false);
    const [withDrawOpen, setWithDrawOpen] = React.useState(false);
    const [showRemoveFile, setShowRemoveFile] = React.useState(false);
    const [currentEditAttachment, setCurrentEditAttachment] = React.useState();
    const [showCompetent, setShowCompetent] = React.useState(false);
    const [totalRemaining, setTotalRemaining] = React.useState();
    const [takenCompLeave, setTakenCompLeave] = React.useState('');
    const [ifApprovedCompLeave, setIfApprovedCompLeave] = React.useState('');
    const [compLeaveProgressValue, setCompLeaveProgressValue] = React.useState(0);
    const [showNewCompLeave, setShowNewCompLeave] = React.useState(true);
    const [confirmationDialog, setConfirmationDialog] = React.useState({
        open: false,
        title: '',
        msg: '',
        uploadingMessage: false,
        error: false
    });
    const [checkDuplicateApplication, setCheckDuplicateApplication] = React.useState([]);

    const annualLeave = intl.formatMessage({ id: 'guideline.Annual Leave' }),
        sickLeave = intl.formatMessage({ id: 'guideline.Sick Leave' }),
        nopayLeave = intl.formatMessage({ id: 'guideline.No Pay Leave' }),
        otherLeave = intl.formatMessage({ id: 'guideline.Other Leave' }),
        compensationLeave = intl.formatMessage({ id: 'guideline.Compensation Leave' }),
        birthdayLeave = intl.formatMessage({ id: 'guideline.Birthday Leave' }),
        maternityLeave = intl.formatMessage({ id: 'guideline.Maternity Leave' });
    const isCompLeave = typeName === compensationLeave;

    // Get employee data from backend api
    React.useEffect(() => {
        if (employeeId) {
            values.employeeId = employeeId;
            values.employeeName = employeeName;
            const now = new Date().getFullYear();
            const lastYear = now - 1;
            const nextYear = now + 1;
            customAxios.get(`/get_pending_approval_records?lastYear=${lastYear}&nextYear=${nextYear}`)
                .then(res => {
                    setCheckDuplicateApplication(res.data)
                }, error => {
                    if (error.response.status === 401) {
                        history.push('/home');
                    }
                });
        }
    }, [employeeId])

    // Different UI handling
    React.useEffect(() => {
        switch (mode) {
            case window.global.submitMode:
                setFormTitle(<FormattedMessage
                    id="new_application.leave_applicaion"
                />);
                setSubmitButtonText(<FormattedMessage
                    id="new_application.submit"
                />);
                setDisabled(false);
                setSubmitButton(true);
                setWithDrawnButton(false);
                setCancelButton(false);
                setApproveButton(false);
                setShowDropzone(true);
                setShowAlert(true);
                setShowRemoveFile(true);
                setShowNewCompLeave(isCompLeave && staffDuty != window.global.shiftDuty);
                if (staffDuty === window.global.officeHours) {
                    setShowWarning(false);
                    setShowShiftWarningMessage(false);
                } else if (staffDuty === window.global.shiftDuty) {
                    setShowWarning(true);
                    setShowShiftWarningMessage(true);
                }
                break;
            case window.global.formMode:
                setFormTitle(<FormattedMessage
                    id="new_application.leave_applicaion"
                />)
                setSubmitButtonText(<FormattedMessage
                    id="new_application.submit"
                />);
                setDisabled(false)
                setSubmitButton(true)
                setWithDrawnButton(false);
                setCancelButton(false);
                setApproveButton(false)
                setShowDropzone(true);
                setShowAlert(true);
                setShowNewCompLeave(isCompLeave && staffDuty != window.global.shiftDuty);
                if (annualTotal !== undefined) {
                    setTotalBalance(Number(annualTotal).toFixed(1));
                }
                setShowRemoveFile(true);
                if (staffDuty === window.global.officeHours) {
                    setShowWarning(false);
                    setShowShiftWarningMessage(false);
                } else if (staffDuty === window.global.shiftDuty) {
                    setShowWarning(true);
                    setShowShiftWarningMessage(true);
                }
                break;
            case window.global.editMode:
                setFormTitle(intl.formatMessage({ id: 'new_application.leave_applicaion' }) + ' (' + intl.formatMessage({ id: 'status.' + editStatus }) + ')');
                setSubmitButtonText(<FormattedMessage
                    id="myleave.update"
                />);
                setDisabled(true);
                setSubmitButton(false);
                setWithDrawnButton(true);
                setCancelButton(false);
                setApproveButton(false);
                setShowNewCompLeave(isNewCompLeave);
                if (String(editStatus) === window.global.submitted) {
                    setShowAlert(true);
                    setShowDropzone(true);
                } else {
                    setShowAlert(false);
                    setShowDropzone(false);
                }
                setShowRemoveFile(false);
                if (staffDuty === window.global.officeHours) {
                    setShowWarning(false);
                    setShowShiftWarningMessage(false);
                } else if (staffDuty === window.global.shiftDuty) {
                    setShowWarning(true);
                    setShowShiftWarningMessage(true);
                }
                switch (editTypeName) {
                    case annualLeave:
                        if (String(editStatus) === window.global.pending || String(editStatus) === window.global.submitted) {
                            setShowCalculator(true);
                        } else {
                            setShowCalculator(false);
                        }
                        setShowDropzoneValidator(false);
                        setShowReasonValidator(false);
                        setTotalBalance(Number(annualTotal).toFixed(1));
                        break;
                    case sickLeave:
                        setShowCalculator(false);
                        setShowDropzoneValidator(true);
                        setShowReasonValidator(false);
                        setTotalBalance(undefined);
                        break;
                    case nopayLeave:
                    case otherLeave:
                        setShowCalculator(false);
                        setShowDropzoneValidator(false);
                        setShowReasonValidator(true);
                        setTotalBalance(undefined);
                        break;
                    case compensationLeave:
                        setShowCalculator(isNewCompLeave && (String(editStatus) === window.global.pending || String(editStatus) === window.global.submitted));
                        break;
                    default:
                        setShowCalculator(false);
                        if (editTypeName === compensationLeave ||
                            editTypeName === birthdayLeave) {
                            setShowDropzoneValidator(false);
                        } else {
                            setShowDropzoneValidator(true);
                        }
                        setShowReasonValidator(false);
                        setTotalBalance(undefined);
                        break;
                }

                var checkTimeExpired;
                if (editStartDate !== '') {
                    var moEditStartDate = moment(editStartDate, window.global.momentFormat);
                    checkTimeExpired = moment().isSameOrAfter(moEditStartDate);
                } else {
                    checkTimeExpired = '';
                }

                if (String(editStatus) !== window.global.submitted || checkTimeExpired === true) {
                    setShowWarning(false);
                    setShowShiftWarningMessage(false);
                    setDisabled(true);
                    setSubmitButton(false);
                    setWithDrawnButton(false);
                    setApproveButton(false);
                    setShowRemoveFile(false);
                }
                break;
            case window.global.approveMode:
                setFormTitle(employeeName + ' (' + intl.formatMessage({ id: 'status.' + editStatus }) + ')');
                setDisabled(true);
                setShowAlert(false);
                setSubmitButton(false);
                setWithDrawnButton(false);
                setCancelButton(false);
                if (String(editStatus) === window.global.pending || String(editStatus) === window.global.submitted) {
                    setApproveButton(true);
                } else {
                    setApproveButton(false);
                }
                setShowDropzone(false);
                setShowRemoveFile(false);
                setShowNewCompLeave(isNewCompLeave);
                switch (editTypeName) {
                    case annualLeave:
                        setShowCalculator(true);
                        setShowDropzoneValidator(false);
                        setShowReasonValidator(false);
                        setTotalBalance(Number(annualTotal).toFixed(1));
                        break;
                    case sickLeave:
                        setShowCalculator(false);
                        setShowDropzoneValidator(true);
                        setShowReasonValidator(false);
                        break;
                    case nopayLeave:
                    case otherLeave:
                        setShowCalculator(false);
                        setShowDropzoneValidator(false);
                        setShowReasonValidator(true);
                        break;
                    case compensationLeave:
                        setShowCalculator(isNewCompLeave);
                        break;
                    default:
                        setShowCalculator(false);
                        if (editTypeName === compensationLeave ||
                            editTypeName === birthdayLeave) {
                            setShowDropzoneValidator(false);
                        } else {
                            setShowDropzoneValidator(true);
                        }
                        setShowReasonValidator(false);
                        break;
                }
                break;
            case window.global.viewMode:
                const checkHrAdminRole = (isHrAdmin) => {
                    const cancelable = String(editStatus) === window.global.pending || String(editStatus) === window.global.submitted || String(editStatus) === window.global.approved;
                    setCancelButton(isHrAdmin && cancelable);
                }

                const isHrAdminRole = JSON.parse(localStorage.getItem('isHrAdminRole'));
                if (isHrAdminRole === null) {
                    customAxios.get('/get_permission')
                    .then(res => {
                        const isHrAdmin = res.data.hr_admin === true;
                        localStorage.setItem('isHrAdminRole', isHrAdmin);
                        checkHrAdminRole(isHrAdmin);
                    })
                } else {
                    checkHrAdminRole(isHrAdminRole);
                }

                setFormTitle(employeeName + ' (' + intl.formatMessage({ id: 'status.' + editStatus }) + ')');
                setDisabled(true);
                setShowAlert(false);
                setSubmitButton(false);
                setWithDrawnButton(false);
                setShowDropzone(false);
                setShowNewCompLeave(isNewCompLeave);
                switch (editIsApprover) {
                    case true:
                        if (String(editStatus) === window.global.pending || String(editStatus) === window.global.submitted) {
                            setApproveButton(true);
                        } else {
                            setApproveButton(false);
                        }
                        break;
                    case false:
                        setApproveButton(false);
                        break;
                }
                setShowRemoveFile(false);
                switch (editTypeName) {
                    case annualLeave:
                        setShowCalculator(false);
                        setShowDropzoneValidator(false);
                        setShowReasonValidator(false);
                        break;
                    case sickLeave:
                        setShowCalculator(false);
                        setShowDropzoneValidator(true);
                        setShowReasonValidator(false);
                        break;
                    case nopayLeave:
                    case otherLeave:
                        setShowCalculator(false);
                        setShowDropzoneValidator(false);
                        setShowReasonValidator(true);
                        break;
                    case compensationLeave:
                        setShowCalculator(false);
                        break;
                    default:
                        setShowCalculator(false);
                        if (editTypeName === compensationLeave ||
                            editTypeName === birthdayLeave) {
                            setShowDropzoneValidator(false);
                        } else {
                            setShowDropzoneValidator(true);
                        }
                        setShowReasonValidator(false);
                        break;
                }
        }
        // Input data handling
        var editStartDateYear = Number(moment(new Date(editStartDate)).format('YYYY'));
        var editStartDateMonth = Number(moment(new Date(editStartDate)).format('MM'));
        var editStartDateDay = Number(moment(new Date(editStartDate)).format('DD'));
        var editUntilDateYear = Number(moment(new Date(editUntilDate)).format('YYYY'));
        var editUntilDateMonth = Number(moment(new Date(editUntilDate)).format('MM'));
        var editUntilDateDay = Number(moment(new Date(editUntilDate)).format('DD'));
        switch (mode) {
            case window.global.submitMode:
                break;
            case window.global.formMode:
                values.typeId = defaultType['id'];
                setTypeName(defaultType['type']);
                setSelectedStartDate({
                    year: editStartDateYear,
                    month: editStartDateMonth,
                    day: editStartDateDay
                })
                setSelectedUntilDate({
                    year: editUntilDateYear,
                    month: editUntilDateMonth,
                    day: editUntilDateDay
                })
                values.startTime = editStartTime;
                values.endTime = editEndTime;
                break;
            default:
                values.typeId = editTypeId;
                setTypeName(editTypeName);
                setSelectedStartDate({
                    year: editStartDateYear,
                    month: editStartDateMonth,
                    day: editStartDateDay
                })
                setSelectedUntilDate({
                    year: editUntilDateYear,
                    month: editUntilDateMonth,
                    day: editUntilDateDay
                })
                values.startTime = editStartTime
                values.endTime = editEndTime
                values.reason = editReason
                setCurrentEditAttachment(editAttachment);
                values.attachment = editAttachment
                values.attachmentPath = editAttachmentPath
                setValues({
                    ...values,
                    attachment: editAttachment
                });
                values.status = editStatus
        }

        customAxios.get(`/get_holiday`)
            .then(res => {
                var data = [];
                var unformattedData = [];
                var getHoliday = res.data;
                for (var i = 0; i < getHoliday.length; i++) {
                    var holidayYear = moment(new Date(getHoliday[i].date)).format('YYYY');
                    var holidayMonth = moment(new Date(getHoliday[i].date)).format('M');
                    var holidayDay = moment(new Date(getHoliday[i].date)).format('D');
                    unformattedData.push(getHoliday[i].date);
                    data.push({
                        year: Number(holidayYear),
                        month: Number(holidayMonth),
                        day: Number(holidayDay),
                        className: 'highlight'
                    });
                }
                setHoliday(data);
                setUnformattedHoliday(unformattedData);
            })
    }, [mode, staffDuty, annualTotal, defaultType]);

    React.useEffect(() => {
        calculateTotalHours(compLeaveRows);
    }, [compLeaveRows]);

    function calculateTotalHours(compLeaveRows) {
        let totalHours = 0;
        compLeaveRows.forEach((row) => {
            totalHours += Number(row.remaining) || 0;
        });

        setTotalRemaining(totalHours);
    }

    React.useEffect(() => {
        let get_leave_type_url = '/get_leave_type';
        let showEffectiveLeaveTypes = false;
        if (mode !== 'Approve Mode' && mode !== 'View Mode') {
            get_leave_type_url = '/get_leave_type?effective=true'
            showEffectiveLeaveTypes = true;
        }
        customAxios.get(get_leave_type_url)
            .then(res => {
                let getLeaveTypes = res.data;

                // Remove "Compensation Leave" type if shift duty role
                if (staffDuty == window.global.shiftDuty && (mode == window.global.submitMode || mode == window.global.formMode)) {
                    let index = getLeaveTypes.findIndex(item => item.id === 11);
                    if (index !== -1) {
                        getLeaveTypes.splice(index, 1);
                    }
                }

                setTypes(getLeaveTypes);
                if (showEffectiveLeaveTypes && getLeaveTypes[0]['id'] !== LeaveTypes.ANNUAL_LEAVE) {
                    setShowCalculator(false)
                    setShowDropzoneValidator(false);
                    setShowReasonValidator(true);
                    if (isOfficeStaff === true) {
                        setShowWarning(false);
                    } else {
                        setShowWarning(true);
                    }
                    setShowSickWarningMessage(false);
                    setTotalBalance(undefined);
                    setDefaultType({
                        id: LeaveTypes.OTHER_LEAVE,
                        type: otherLeave,
                    })
                } else {
                    setDefaultType({
                        id: LeaveTypes.ANNUAL_LEAVE,
                        type: annualLeave,
                    })
                }
            })
    }, [mode, staffDuty]);

    // Different staff duty handling
    React.useEffect(() => {
        if (staffDuty === window.global.officeHours) {
            isOfficeStaff = true;
            setDateTime([window.global.am, window.global.pm]);
            timePlaceholder = intl.formatMessage({ id: 'new_application.am_pm' })
        } else if (staffDuty === window.global.shiftDuty) {
            isOfficeStaff = false;
            setDateTime([window.global.sectionOne, window.global.sectionTwo]);
            timePlaceholder = intl.formatMessage({ id: 'new_application.section_one_section_two' })
        }
    }, [staffDuty])

    React.useEffect(() => {
        if (dateTime.length && types.length) {
            setShowCompetent(true);
        }
    }, [dateTime, types])

    const [values, setValues] = React.useState({
        typeId: '',
        startDate: '',
        startTime: '',
        untilDate: '',
        endTime: '',
        reason: '',
        attachment: [],
        attachmentPath: '',
        status: '',
    });
    
    const handleInputChange = (field, value) => {
        setValues({
            ...values,
            [field]: value,
        });
    };

    // Datepicker variable
    const [selectedStartDate, setSelectedStartDate] = React.useState(null);
    const [selectedUntilDate, setSelectedUntilDate] = React.useState(null);

    // For New Comp Leave Application
    React.useEffect(() => {
        if (isCompLeave && selectedStartDate && selectedUntilDate && values.startTime && values.endTime) {
            calculateCompLeaveRelatedHours(selectedStartDate, selectedUntilDate, values.startTime, values.endTime);
        }
    }, [isCompLeave, selectedStartDate, selectedUntilDate, values.startTime, values.endTime, typeName, totalRemaining, unformattedHoliday]);

    React.useEffect(() => {
        if (mlReadOnly && selectedStartDate) {
            maternityFixPeriod();
        } else if (!disabled && !editUntilDate) {
            setSelectedUntilDate(selectedStartDate);
        }
        if (mlReadOnly && isOfficeStaff) {
            setValues({
                ...values,
                startTime: window.global.am,
                endTime: window.global.pm,
            });
        } else if (mlReadOnly) {
            setValues({
                ...values,
                startTime: window.global.sectionOne,
                endTime: window.global.sectionTwo,
            });
        }
    }, [mlReadOnly])

    React.useEffect(() => {
        if (mlReadOnly && selectedStartDate) {
            maternityFixPeriod();
        }
        if (mlReadOnly && isOfficeStaff) {
            setValues({
                ...values,
                startTime: window.global.am,
                endTime: window.global.pm,
            });
        } else if (mlReadOnly) {
            setValues({
                ...values,
                startTime: window.global.sectionOne,
                endTime: window.global.sectionTwo,
            });
        }
    }, [selectedStartDate])

    if (selectedStartDate != null) {
        minimumUntilDate.year = selectedStartDate.year
        minimumUntilDate.month = selectedStartDate.month
        minimumUntilDate.day = selectedStartDate.day
    }

    if (selectedStartDate && selectedUntilDate && values.startTime && values.endTime) {
        if (!checkIsNewCompLeave(values.startTime) || !checkIsNewCompLeave(values.endTime)) {
            differentTimeHandle(selectedStartDate, selectedUntilDate, values.startTime, values.endTime)
        }
    } else if (selectedStartDate && selectedUntilDate) {
        differentTimeHandle(selectedStartDate, selectedUntilDate)
    }
  
    const handleConfirmOpen = async (act) => {
        if (isNewCompLeave && act === 'approve') {
            const startDateTime = moment(`${editStartDate} ${editStartTime}`, "YYYY/MM/DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
            const endDateTime = moment(`${editUntilDate} ${editEndTime}`, "YYYY/MM/DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
            const userId = employeeId || values.employeeId;
    
            const res = await customAxios.get(`/get_total_remaining_by_date_time?startDate=${startDateTime}&endDate=${endDateTime}&id=${userId}&idType=employeeId`);
            const remainingBalance = res.data.total_remaining;
    
            if (Number(remainingBalance) - Number(takenCompLeave) < 0) {
                alert(intl.formatMessage({id: 'error.no_enough_remaining_balance_CL'}));
                return;
            }
        }

        action = act
        if (act === 'approve' || act === 'reject') {
            setApproveOpen(true);
        } else if (act === 'withdraw' || act === 'cancel') {
            setWithDrawOpen(true);
        }
    };
    const handleConfirmClose = () => {
        if (action === 'approve' || action === 'reject') {
            setApproveOpen(false);
        } else if (action === 'withdraw' || action === 'cancel') {
            setWithDrawOpen(false);
        }
    };

    function calculateAllowance(dateDiff, timeDiff, count) {
        ifApproved = (totalBalance - dateDiff - timeDiff + count).toFixed(1);
        taken = (dateDiff + timeDiff - count).toFixed(1);
        progressValue = ((1 - Number(ifApproved) / Number(totalBalance)) * 100);
    }

    function calculateCompLeaveRelatedHours(from, to, startTime, endTime) {
        if (!from || !to || !startTime || !endTime) return;
    
        const startDate = moment({ year: from.year, month: from.month - 1, day: from.day });
        const endDate = moment({ year: to.year, month: to.month - 1, day: to.day });
    
        let totalHours = 0;
        const workMorningStart = moment('09:00', 'HH:mm');
        const workMorningEnd = moment('13:00', 'HH:mm');
        const workAfternoonStart = moment('14:00', 'HH:mm');
        const workAfternoonEnd = moment('18:00', 'HH:mm');
        const lunchStart = moment('13:00', 'HH:mm');
        const lunchEnd = moment('14:00', 'HH:mm');
    
        for (let day = startDate.clone(); day.isSameOrBefore(endDate); day.add(1, 'days')) {
            if (unformattedHoliday !== undefined) {
                if (day.isoWeekday() <= 5 && !unformattedHoliday.includes(day.format('YYYY-MM-DD'))) {
                    let currentStart = day.isSame(startDate) ? moment(startTime, 'HH:mm') : workMorningStart;
                    let currentEnd = day.isSame(endDate) ? moment(endTime, 'HH:mm') : workAfternoonEnd;
    
                    // Calculate morning work hours
                    let morningHours = 0;
                    if (currentStart.isBefore(workMorningEnd) && currentEnd.isAfter(workMorningStart)) {
                        morningHours = moment.min(currentEnd, workMorningEnd).diff(moment.max(currentStart, workMorningStart), 'hours', true);
                    }
    
                    // Calculate afternoon work hours
                    let afternoonHours = 0;
                    if (currentStart.isBefore(workAfternoonEnd) && currentEnd.isAfter(workAfternoonStart)) {
                        afternoonHours = moment.min(currentEnd, workAfternoonEnd).diff(moment.max(currentStart, workAfternoonStart), 'hours', true);
                    }
    
                    totalHours += morningHours + afternoonHours;
                }
            }
        }
    
        const takenCompLeave = totalHours;
        const ifApprovedCompLeave = totalRemaining - takenCompLeave;
        const compLeaveProgressValue = (1 - (totalRemaining - totalHours) / totalRemaining) * 100;
    
        setTakenCompLeave(takenCompLeave);
        setIfApprovedCompLeave(ifApprovedCompLeave);
        setCompLeaveProgressValue(compLeaveProgressValue);
    }

    function differentTimeHandle(from, to, time1, time2) {
        let diff;
        const unformatStartDate = toNativeDate(from);
        const unformatUntilDate = toNativeDate(to);
        const momentStartDate = moment(unformatStartDate);
        const momentUntilDate = moment(unformatUntilDate);

        if (moment(unformatUntilDate).isSameOrAfter(momentStartDate) === true) {
            diff = getDifferenceInDate(unformatStartDate, unformatUntilDate);
        } else {
            diff = 0;
        }

        if (time1 === undefined && time2 === undefined) {
            if (moment(momentUntilDate).isBefore(momentStartDate) === true) {
                setSelectedUntilDate(selectedStartDate);
            }
        } else {
            var weekendDaysArray = [];
            var holidayArray = [];
            var momentSelectedDay = rangeToDayConverter(momentStartDate, momentUntilDate);
            for (var i = 0; i < momentSelectedDay.length; i++) {
                if (business.isWeekendDay(moment(momentSelectedDay[i], window.global.momentFormat)) === true) {
                    weekendDaysArray.push(momentSelectedDay[i]);
                }
            }
            if (unformattedHoliday !== undefined) {
                for (var i = 0; i < momentSelectedDay.length; i++) {
                    for (var j = 0; j < unformattedHoliday.length; j++) {
                        var momentHoliday = moment(unformattedHoliday[j]);
                        if (moment(momentSelectedDay[i], window.global.momentFormat).isSame(momentHoliday) === true && business.isWeekDay(momentHoliday) === true) {
                            holidayArray.push(momentSelectedDay[i]);
                        }
                    }
                }
            }

            var concat = weekendDaysArray.concat(holidayArray);
            var concatCount = mlReadOnly? 0 : concat.length;

            if (isOfficeStaff === true) {
                if (!isNewCompLeave) {
                    if (concat.includes(moment(momentStartDate).format(window.global.momentFormat)) === true && concat.includes(moment(momentUntilDate).format(window.global.momentFormat)) === false) {
                        switch (time1) {
                            case window.global.am:
                                if (time2 === window.global.am) {
                                    calculateAllowance(diff, 0.5, concatCount);
                                } else if (time2 === window.global.pm) {
                                    calculateAllowance(diff, 1, concatCount);
                                }
                                break;
                            case window.global.pm:
                                if (time2 === window.global.am) {
                                    calculateAllowance(diff, 0.5, concatCount);
                                } else if (time2 === window.global.pm) {
                                    calculateAllowance(diff, 1, concatCount);
                                }
                                break;
                        }
                    } else if (concat.includes(moment(momentStartDate).format(window.global.momentFormat)) === false && concat.includes(moment(momentUntilDate).format(window.global.momentFormat)) === true) {
                        switch (time1) {
                            case window.global.am:
                                if (time2 === window.global.am) {
                                    calculateAllowance(diff, 1, concatCount);
                                } else if (time2 === window.global.pm) {
                                    calculateAllowance(diff, 1, concatCount);
                                }
                                break;
                            case window.global.pm:
                                if (time2 === window.global.am) {
                                    calculateAllowance(diff, 0.5, concatCount);
                                } else if (time2 === window.global.pm) {
                                    calculateAllowance(diff, 0.5, concatCount);
                                }
                                break;
                        }
                    } else if (concat.includes(moment(momentStartDate).format(window.global.momentFormat)) === true && concat.includes(moment(momentUntilDate).format(window.global.momentFormat)) === true) {
                        switch (time1) {
                            case window.global.am:
                                if (time2 === window.global.am) {
                                    calculateAllowance(diff, 1, concatCount);
                                } else if (time2 === window.global.pm) {
                                    calculateAllowance(diff, 1, concatCount);
                                }
                                break;
                            case window.global.pm:
                                if (time2 === window.global.am) {
                                    calculateAllowance(diff, 1, concatCount);
                                } else if (time2 === window.global.pm) {
                                    calculateAllowance(diff, 1, concatCount);
                                }
                                break;
                        }
                    } else if (concat.includes(moment(momentStartDate).format(window.global.momentFormat)) === false && concat.includes(moment(momentUntilDate).format(window.global.momentFormat)) === false) {
                        switch (time1) {
                            case window.global.am:
                                if (time2 === window.global.am) {
                                    calculateAllowance(diff, 0.5, concatCount);
                                } else if (time2 === window.global.pm) {
                                    calculateAllowance(diff, 1, concatCount);
                                }
                                break;
                            case window.global.pm:
                                if (time2 === window.global.am) {
                                    calculateAllowance(diff, 0, concatCount);
                                } else if (time2 === window.global.pm) {
                                    calculateAllowance(diff, 0.5, concatCount);
                                }
                                break;
                        }
                    }
                }
            } else {
                switch (time1) {
                    case window.global.sectionOne:
                        if (time2 === window.global.sectionOne) {
                            calculateAllowance(diff, 0.5, 0);
                        } else if (time2 === window.global.sectionTwo) {
                            calculateAllowance(diff, 1, 0);
                        }
                        break;
                    case window.global.sectionTwo:
                        if (time2 === window.global.sectionOne) {
                            calculateAllowance(diff, 0, 0);
                        } else if (time2 === window.global.sectionTwo) {
                            calculateAllowance(diff, 0.5, 0);
                        }
                        break;
                }
            }

            if (moment(momentUntilDate).isBefore(momentStartDate) === true) {
                setSelectedUntilDate(selectedStartDate);
            }

            if (moment(momentStartDate).isSame(momentUntilDate) === true && values.startTime === window.global.pm && values.endTime === window.global.am ||
                moment(momentStartDate).isSame(momentUntilDate) === true && values.startTime === window.global.sectionTwo && values.endTime === window.global.sectionOne) {
                values.startTime = ''
                values.endTime = ''
                taken = '';
                ifApproved = '';
            }
        }
    }

    function maternityFixPeriod() {
        const unformatStartDate = toNativeDate(selectedStartDate);
        const momentStartDate = moment(unformatStartDate, "YYYY-MM-DD");
        const momentUntilDate = moment(momentStartDate, "YYYY-MM-DD").add(97, 'days');

        setSelectedUntilDate({
            year: Number(momentUntilDate.format('YYYY')),
            month: Number(momentUntilDate.format('MM')),
            day: Number(momentUntilDate.format('DD'))
        });
    }

    // Convert type id to string
    function typeIdtoName(id) {
        var findType = types.filter(type => type.id === id);
        var convertTypetoName;
        if (localStorage.getItem('locale') === 'en') {
            convertTypetoName = findType[0].name;
        } else if (localStorage.getItem('locale') === 'zh') {
            convertTypetoName = findType[0].name_zh;
        }
        return convertTypetoName
    }

    // Selector change handling
    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        
        if (name === 'typeId') {
            const getTypeName = typeIdtoName(value);
            setTypeName(getTypeName);
            setMlReadOnly(false);
            setShowNewCompLeave((getTypeName === compensationLeave) && (staffDuty != window.global.shiftDuty));

            switch (getTypeName) {
                case annualLeave:
                    setShowCalculator(true)
                    setShowDropzoneValidator(false);
                    setShowReasonValidator(false);
                    setTotalBalance(Number(annualTotal).toFixed(1));
                    setShowSickWarningMessage(false);
                    if (isOfficeStaff === true) {
                        setShowWarning(false);
                    } else {
                        setShowWarning(true);
                    }
                    break;
                case sickLeave:
                    setShowCalculator(false)
                    setShowDropzoneValidator(true);
                    setShowReasonValidator(false);
                    setShowWarning(true);
                    setShowSickWarningMessage(true);
                    setTotalBalance(undefined);
                    break;
                case nopayLeave:
                case otherLeave:
                    setShowCalculator(false)
                    setShowDropzoneValidator(false);
                    setShowReasonValidator(true);
                    if (isOfficeStaff === true) {
                        setShowWarning(false);
                    } else {
                        setShowWarning(true);
                    }
                    setShowSickWarningMessage(false);
                    setTotalBalance(undefined);
                    break;
                default:
                    setShowCalculator((getTypeName === compensationLeave) && (staffDuty != window.global.shiftDuty));
                    if (getTypeName === compensationLeave ||
                        getTypeName === birthdayLeave) {
                        setShowDropzoneValidator(false);
                    } else {
                        setShowDropzoneValidator(true);
                    }
                    if (getTypeName === maternityLeave) {
                        setMlReadOnly(true);
                    }
                    setShowReasonValidator(false);
                    setShowSickWarningMessage(false);
                    if (isOfficeStaff === true) {
                        setShowWarning(false);
                    } else {
                        setShowWarning(true);
                    }
                    setTotalBalance(undefined);
                    break;
            }
        }

        if (name == 'typeId') {
            setValues({
                ...values,
                [name]: value,
                startTime: '',
                endTime: '',
            });
            taken = '';
            ifApproved = '';
            progressValue = 0;
            setTakenCompLeave('');
            setIfApprovedCompLeave('');
            setCompLeaveProgressValue(0);
        } else {
            setValues({
                ...values,
                [name]: value,
            });
        }
    };

    const handleUpload = async (files) => {
        const promises = [];
        setShowFileUploaded(false);
        setConfirmationDialog({
            open: true,
            title: intl.formatMessage({ id: 'new_application.dropzone_file_uploading' }),
            uploadingMessage: true,
            error: false
        });

        files.forEach((file, idx) => {
            promises.push(sendRequest(file, idx));
        });

        try {
            await Promise.all(promises)
                .then(responses => {
                    const result = responses.map((response) => response.data.info);
                    setValues({
                        ...values,
                        attachment: result
                    });
                })
                .catch(error => {
                    setConfirmationDialog({
                        open: true,
                        title: intl.formatMessage({ id: 'new_application.dropzone_fail_upload' }),
                        uploadingMessage: true,
                        error: true
                    });
                });
        } catch (error) {
            setConfirmationDialog({
                open: true,
                title: intl.formatMessage({ id: 'new_application.dropzone_fail_start' }),
                uploadingMessage: true,
                error: true
            });
        }
    }

    const sendRequest = (file, idx) => {
        var filename;
        if (!isAlreadyUpload(file.name)) {
            filename = file.name;
        } else {
            var filenameToArray = file.name.split('.');
            var main = filenameToArray.slice(0, filenameToArray.length - 1).join(".");
            var extension = filenameToArray[filenameToArray.length - 1];
            var timestamp = moment().format('YYYY_MM_DD_hh_mm_ss');
            filename = main + '(' + timestamp + ').' + extension;
        }

        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append("attachment", file, filename);
            const path = isCompLeave ? '/comp_leave_attachment' : '/attachment';

            customAxios.post(path, formData)
                .then(res => {
                    resolve(res);
                    setUploadedFileName(intl.formatMessage({ id: 'new_application.dropzone_file' }) +
                        filename +
                        intl.formatMessage({ id: 'new_application.dropzone_successfully_added' }));
                    setShowFileUploaded(true);
                    setConfirmationDialog({
                        open: false,
                        title: intl.formatMessage({ id: 'new_application.dropzone_file_uploading' }),
                        uploadingMessage: true,
                        error: false
                    });
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    const isAlreadyUpload = (filename) => {
        return values.attachment.some(row => row.filename === filename);
    }

    const handleAttachmentClick = url => {
        window.open(url, "_blank");
    };

    const handleAttachmentDelete = (idx, file_id) => {
        setConfirmationDialog({
            open: true,
            title: intl.formatMessage({ id: 'new_application.delete_attachment_warning_title' }),
            msg: intl.formatMessage({ id: 'new_application.delete_attachment_warning_msg' }),
            target: {
                idx: idx,
                file_id: file_id,
            },
            uploadingMessage: false,
            error: false
        });
    }

    // Application summary pop up handling
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    // Form submission handling
    const handleSubmit = async (evt) => {
        let isValid = true;
        evt.preventDefault();
        values.startDate = moment({
            year: selectedStartDate.year,
            month: selectedStartDate.month - 1,
            day: selectedStartDate.day
        }).format(window.global.displayFormat);

        values.untilDate = moment({
            year: selectedUntilDate.year,
            month: selectedUntilDate.month - 1,
            day: selectedUntilDate.day
        }).format(window.global.displayFormat);

        const formatStartDate = values.startDate.replaceAll('/', '-');
        const formatEndDate = values.untilDate.replaceAll('/', '-');

        // Check for time overlap - common logic for both CompLeave and non-CompLeave applications
        if (values.startTime && values.endTime) {
            const hasOverlap = checkTimeOverlap(
                formatStartDate,
                values.startTime,
                formatEndDate,
                values.endTime,
                checkDuplicateApplication
            );

            if (hasOverlap) {
                alert(intl.formatMessage({id: 'error.multiple_leave'}));
                isValid = false;
                return;
            }
        }

        if ((!isCompLeave && Number(taken) === 0) || (staffDuty !== window.global.shiftDuty && isCompLeave && Number(takenCompLeave) <= 0)) {
            alert(intl.formatMessage({ id: 'error.invalid_day' }));
            isValid = false;
            return;
        }

        if (isCompLeave && (!values.startTime.includes('Section') || !values.endTime.includes('Section'))) {
            const startTimeMinutes = moment(values.startTime, 'HH:mm').format('mm');
            const endTimeMinutes = moment(values.endTime, 'HH:mm').format('mm');

            if (![startTimeMinutes, endTimeMinutes].every(minute => ['00', '30'].includes(minute))) {
                alert(intl.formatMessage({ id: 'error.allow_only_00_or_30_minutes_input' }));
                isValid = false;
                return;
            }

            const startDateTime = moment(`${values.startDate} ${values.startTime}`, "YYYY/MM/DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
            const endDateTime = moment(`${values.untilDate} ${values.endTime}`, "YYYY/MM/DD HH:mm").format("YYYY-MM-DD HH:mm:ss");

            const res = await customAxios.get(`/get_total_remaining_by_date_time?startDate=${startDateTime}&endDate=${endDateTime}`);
            const remainingBalance = res.data.total_remaining;

            if (Number(remainingBalance) - Number(takenCompLeave) < 0) {
                alert(intl.formatMessage(
                    {id: 'error.insufficient_remaining_balance_for_apply_CL'},
                    {startDate: formatStartDate, endDate: formatEndDate, remaining: remainingBalance},
                ));
                isValid = false;
                return;
            }
        }

        if (Number(ifApproved) < 0 && typeName === annualLeave && showAlert === true && totalBalance !== undefined) {
            alert(intl.formatMessage({ id: 'error.entitled_is_not_enough' }));
            isValid = false;
            switch (mode) {
                case window.global.editMode:
                    values.typeId = editTypeId;
                    var editStartDateYear = Number(moment(new Date(editStartDate)).format('YYYY'));
                    var editStartDateMonth = Number(moment(new Date(editStartDate)).format('MM'));
                    var editStartDateDay = Number(moment(new Date(editStartDate)).format('DD'));
                    setSelectedStartDate({
                        year: editStartDateYear,
                        month: editStartDateMonth,
                        day: editStartDateDay
                    })
                    values.startTime = editStartTime
                    var editUntilDateYear = Number(moment(new Date(editUntilDate)).format('YYYY'));
                    var editUntilDateMonth = Number(moment(new Date(editUntilDate)).format('MM'));
                    var editUntilDateDay = Number(moment(new Date(editUntilDate)).format('DD'));
                    setSelectedUntilDate({
                        year: editUntilDateYear,
                        month: editUntilDateMonth,
                        day: editUntilDateDay
                    })
                    values.endTime = editEndTime;
                    break;
                default:
                    values.startTime = '';
                    values.endTime = '';
                    taken = '';
                    ifApproved = '';
                    progressValue = 0;
                    setSelectedStartDate();
                    setSelectedUntilDate();
                    break;
            }
        }

        if (isValid) {
            handleOpen();
        }
    };

    const handleConfirmationCancel = (event, reason) => {
        if (reason !== 'backdropClick') {
            setConfirmationDialog({
                open: false,
                msg: '',
                title: '',
                uploadingMessage: false,
                error: false
            });
        }
    }

    const handleConfirmationConfirm = () => {
        const path = isCompLeave ? '/comp_leave_attachment' : '/attachment';
        customAxios.delete(path + '/' + confirmationDialog.target.file_id)
            .then(res => {
                const n_attachment = values.attachment;
                n_attachment.splice(confirmationDialog.target.idx, 1);
                setValues({
                    ...values,
                    attachment: n_attachment
                });

                setConfirmationDialog({
                    open: false,
                    msg: '',
                    title: '',
                    uploadingMessage: false,
                    error: false
                });

            })
    }

    const closeWarning = () => {
        setShowWarning(false)
    }

    const closeUploadedMessage = () => {
        setShowFileUploaded(false)
    }

    return (
        <MuiThemeProvider theme={thisTheme}>
            {showCompetent ?
                <ValidatorForm
                    ref={form}
                    onSubmit={handleSubmit}
                    onError={errors => (errors)}
                >
                    <React.Fragment>
                        {showWarning &&
                            < Alert className={classes.remark} severity="warning" onClose={closeWarning}>
                                {shiftWarningMessage &&
                                    <p>{intl.formatMessage({ id: 'waring.split_request' })}</p>
                                }
                                {sickWarningMessage &&
                                    ([
                                        <p key='1'>{intl.formatMessage({ id: 'waring.attendance_certificate' })}</p>,
                                        <p key='2'>{intl.formatMessage({ id: 'waring.hard_copy' })}</p>
                                    ])
                                }
                            </Alert>
                        }
                        <FormattedMessage id='new_application.required_message'>
                            {(errorMessage) =>
                                <main className={classes.layout}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <Typography variant="h5" align="left" style={{ fontWeight: 600 }}>
                                                {formTitle}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <div className={classes.submitButtonDiv}>
                                                {submitButton &&
                                                    <Button
                                                        style={{ width: 110 }}
                                                        type="submit"
                                                        variant="contained"
                                                        color="primary"
                                                    >
                                                        {submitButtonText}
                                                    </Button>
                                                }
                                                {withDrawnButton &&
                                                    <Button
                                                        style={{ marginLeft: 10, width: 110 }}
                                                        variant="contained"
                                                        color="secondary"
                                                        onClick={() => handleConfirmOpen('withdraw')}
                                                    >
                                                        {intl.formatMessage({ id: 'myleave.withdraw' })}
                                                    </Button>
                                                }
                                            </div>

                                            {approveButton &&
                                                <div className={classes.submitButtonDiv}>
                                                    <Hidden smDown>
                                                        <Button
                                                            variant="contained"
                                                            style={{ width: 110, backgroundColor: 'green', color: '#FFF' }}
                                                            size="small"
                                                            startIcon={<CheckCircleIcon />}
                                                            onClick={() => handleConfirmOpen('approve')}
                                                        >
                                                            {intl.formatMessage({ id: 'leave_approval.approve' })}
                                                        </Button>
                                                        <Button
                                                            style={{ marginLeft: 10, width: 110 }}
                                                            variant="contained"
                                                            color="secondary"
                                                            size="small"
                                                            startIcon={<CancelIcon />}
                                                            onClick={() => handleConfirmOpen('reject')}
                                                        >
                                                            {intl.formatMessage({ id: 'leave_approval.reject' })}
                                                        </Button>
                                                    </Hidden>

                                                    <Hidden mdUp>
                                                        <Button
                                                            variant="contained"
                                                            style={{ backgroundColor: 'green', color: '#FFF', minWidth: 60 }}
                                                            size="small"
                                                            onClick={() => handleConfirmOpen('approve')}
                                                        >
                                                            <CheckCircleIcon />
                                                        </Button>
                                                        <Button
                                                            style={{ marginLeft: 10, minWidth: 60 }}
                                                            variant="contained"
                                                            color="secondary"
                                                            size="small"
                                                            onClick={() => handleConfirmOpen('reject')}
                                                        >
                                                            <CancelIcon />
                                                        </Button>
                                                    </Hidden>
                                                </div>
                                            }

                                            {cancelButton &&
                                                <div className={classes.submitButtonDiv}>
                                                    <Button
                                                        style={{ width: 110 }}
                                                        variant="contained"
                                                        color="secondary"
                                                        size="small"
                                                        onClick={() => handleConfirmOpen('cancel')}
                                                    >
                                                        {intl.formatMessage({ id: 'new_application.review_cancel' })}
                                                    </Button>
                                                </div>
                                            }
                                        </Grid>

                                        {/* Leave Type Selector */}
                                        <Grid item xs={12}>
                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel id="type_label_id">
                                                    <FormattedMessage
                                                        id="new_application.leave_type"
                                                    /> *</InputLabel>
                                                {types.length && (
                                                    <SelectValidator fullWidth
                                                        disabled={disabled}
                                                        labelId="type_label_id"
                                                        id="type_id"
                                                        value={values.typeId}
                                                        onChange={handleChange}
                                                        inputProps={{
                                                            name: 'typeId',
                                                            id: 'type-native-disabled',
                                                            classes: {
                                                                disabled: classes.disabled
                                                            }

                                                        }}
                                                        label="Leave Type *"
                                                        validators={['required']}
                                                        errorMessages={errorMessage}
                                                        className={classes.selectInput}
                                                    >
                                                        {localStorage.getItem('locale') === 'en' && types.map(({ id, name }, index) => {
                                                            return <MenuItem key={index} value={id}>{name}</MenuItem>;
                                                        })}
                                                        {localStorage.getItem('locale') === 'zh' && types.map(({ id, name_zh }, index) => {
                                                            return <MenuItem key={index} value={id}>{name_zh}</MenuItem>;
                                                        })}
                                                    </SelectValidator>
                                                )}
                                            </FormControl>
                                        </Grid>

                                        {/* From Picker */}
                                        <Grid item md={6} xs={12}>
                                            <div style={disabled ? { pointerEvents: "none" } : { position: "relative", zIndex: "999" }}>
                                                <FormattedMessage id='common.from'>
                                                    {(message) =>
                                                        <DatePickerValidator
                                                            wrapperClassName={classes.datePicker}
                                                            value={selectedStartDate}
                                                            onChange={setSelectedStartDate}
                                                            inputPlaceholder={message + " *"}
                                                            shouldHighlightWeekends
                                                            customDaysClassName={holiday}
                                                            inputClassName={classes.datePickerInput}
                                                            calendarClassName={classes.datePickerCalendar}
                                                            calendarPopperPosition="bottom"
                                                            validators={['required']}
                                                            errorMessages={errorMessage}
                                                        />
                                                    }
                                                </FormattedMessage>
                                            </div>
                                        </Grid>

                                        {/* To Picker */}
                                        <Grid item md={6} xs={12}>
                                            <div style={disabled || mlReadOnly ? { pointerEvents: "none" } : {}}>
                                                <FormattedMessage id='common.to'>
                                                    {(message) =>
                                                        <DatePickerValidator
                                                            wrapperClassName={classes.datePicker}
                                                            value={selectedUntilDate}
                                                            onChange={setSelectedUntilDate}
                                                            minimumDate={minimumUntilDate}
                                                            inputPlaceholder={message + " *"}
                                                            shouldHighlightWeekends
                                                            customDaysClassName={holiday}
                                                            inputClassName={classes.datePickerInput}
                                                            calendarClassName={classes.datePickerCalendar}
                                                            calendarPopperPosition="bottom"
                                                            validators={['required']}
                                                            errorMessages={errorMessage}
                                                        />
                                                    }
                                                </FormattedMessage>
                                            </div>
                                        </Grid>

                                        {/* Start Time Selector */}
                                        <Grid item xs={6}>
                                            <FormControl variant="outlined" fullWidth>
                                                {showNewCompLeave ? (
                                                    <div style={disabled || mlReadOnly ? { pointerEvents: "none" } : {}}>
                                                        <TimePickerValidator
                                                            timeSteps={{ minutes: 30 }}
                                                            minutesStep={30}
                                                            slotProps={{
                                                                popper: {
                                                                    disablePortal: true,
                                                                },
                                                                textField: {
                                                                    error: false,
                                                                    fullWidth: true,
                                                                },
                                                            }}
                                                            closeOnSelect={false}
                                                            value={moment(values.startTime, 'HH:mm:ss')}
                                                            onAccept={(e) => {
                                                                const time = moment(e).format('HH:mm');
                                                                handleInputChange('startTime', time)
                                                            }}
                                                            validators={values.startTime ? ['required'] : ['required', 'isEmpty']}
                                                            errorMessages={intl.formatMessage({ id: 'new_application.required_message' })}
                                                        />
                                                    </div>
                                                ) : (
                                                    <>
                                                        <InputLabel id="endtime_label_id">{timePlaceholder}</InputLabel>
                                                        <SelectValidator fullWidth
                                                            disabled={disabled || mlReadOnly}
                                                            labelId="starttime_label_id"
                                                            id="starttime_id"
                                                            value={values.startTime || ''}
                                                            onChange={handleChange}
                                                            inputProps={{
                                                                name: 'startTime',
                                                                id: 'startTime-native-disabled',
                                                                classes: {
                                                                    disabled: classes.disabled
                                                                }
                                                            }}
                                                            label={timePlaceholder}
                                                            validators={['required']}
                                                            errorMessages={errorMessage}
                                                        >
                                                            {dateTime.map((index) => {
                                                                return <MenuItem key={index} value={index}>{intl.formatMessage({ id: 'new_application.' + index })}</MenuItem>;
                                                            })}
                                                        </SelectValidator>
                                                    </>
                                                )}
                                            </FormControl>
                                        </Grid>

                                        {/* End Time Selector */}
                                        <Grid item xs={6}>
                                            <FormControl variant="outlined" fullWidth>
                                                {showNewCompLeave ? (
                                                    <div style={disabled || mlReadOnly ? { pointerEvents: "none" } : {}}>
                                                        <TimePickerValidator
                                                            timeSteps={{ minutes: 30 }}
                                                            minutesStep={30}
                                                            slotProps={{
                                                                popper: {
                                                                    disablePortal: true,
                                                                },
                                                                textField: {
                                                                    error: false,
                                                                    fullWidth: true,
                                                                },
                                                            }}
                                                            closeOnSelect={false}
                                                            value={moment(values.endTime, 'HH:mm:ss')}
                                                            onAccept={(e) => {
                                                                const time = moment(e).format('HH:mm');
                                                                handleInputChange('endTime', time)
                                                            }}
                                                            validators={values.endTime ? ['required'] : ['required', 'isEmpty']}
                                                            errorMessages={intl.formatMessage({ id: 'new_application.required_message' })}
                                                        />
                                                    </div>
                                                ) : (
                                                    <>
                                                        <InputLabel id="endtime_label_id">{timePlaceholder}</InputLabel>
                                                        <SelectValidator fullWidth
                                                            disabled={disabled || mlReadOnly}
                                                            labelId="endtime_label_id"
                                                            id="endtime_id"
                                                            value={values.endTime}
                                                            onChange={handleChange}
                                                            inputProps={{
                                                                name: 'endTime',
                                                                id: 'endTime-native-disabled',
                                                                classes: {
                                                                    disabled: classes.disabled
                                                                }
                                                            }}
                                                            label={timePlaceholder}
                                                            validators={['required']}
                                                            errorMessages={errorMessage}
                                                        >
                                                            {dateTime.map((index) => {
                                                                return <MenuItem key={index} value={index}>{intl.formatMessage({ id: 'new_application.' + index })}</MenuItem>;
                                                            })}
                                                        </SelectValidator>
                                                    </>
                                                )}
                                            </FormControl>
                                        </Grid>

                                        {/* Allowance Calculator */}                             
                                        {showNewCompLeave ? (
                                            <>
                                                {showCalculator ? (
                                                    <Grid item xs={12}>
                                                        <Grid
                                                            justifyContent="space-between"
                                                            container
                                                            spacing={calculatorSpace}
                                                        >
                                                            <Grid item>
                                                                <Typography type="title" color="inherit">
                                                                    <FormattedMessage
                                                                        id="new_application.entitled"
                                                                    />
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item>
                                                                <Typography type="title" color="inherit">
                                                                    <FormattedMessage
                                                                        id="new_application.taken"
                                                                    />
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item>
                                                                <Typography type="title" color="inherit">
                                                                    <FormattedMessage
                                                                        id="new_application.if_approved"
                                                                    />
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                        <StyledDivider />
                                                        <Grid
                                                            justifyContent="space-between"
                                                            container
                                                            spacing={calculatorSpace}
                                                        >
                                                            <Grid item>
                                                                <Typography type="title" color="inherit">
                                                                    {totalRemaining} {" "}
                                                                    <FormattedMessage
                                                                        id="comp_leave.hours"
                                                                    />
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item>
                                                                <Typography type="title" color="inherit">
                                                                    {takenCompLeave} {" "}
                                                                    <FormattedMessage
                                                                        id="comp_leave.hours"
                                                                    />
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item>
                                                                <Typography type="title" color="inherit">
                                                                    {ifApprovedCompLeave} {" "}
                                                                    <FormattedMessage
                                                                        id="comp_leave.hours"
                                                                    />
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                        <BorderLinearProgress variant="determinate" value={compLeaveProgressValue} />
                                                    </Grid>
                                                ) : (
                                                    <Grid item xs={12}>
                                                        <Grid
                                                            justifyContent="flex-end"
                                                            container
                                                            spacing={calculatorSpace}
                                                        >
                                                            <Grid item>
                                                                <Typography type="title" color="inherit">
                                                                    <FormattedMessage id="new_application.taken"/>
                                                                        : {takenCompLeave} {" "}
                                                                    <FormattedMessage id="comp_leave.hours"/>
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                )}
                                            </>
                                        ) : (
                                            <>
                                                {showCalculator ?
                                                    <Grid item xs={12}>
                                                        <Grid
                                                            justifyContent="space-between"
                                                            container
                                                            spacing={calculatorSpace}
                                                        >
                                                            <Grid item>
                                                                <Typography type="title" color="inherit">
                                                                    <FormattedMessage
                                                                        id="new_application.entitled"
                                                                    />
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item>
                                                                <Typography type="title" color="inherit">
                                                                    <FormattedMessage
                                                                        id="new_application.taken"
                                                                    />
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item>
                                                                <Typography type="title" color="inherit">
                                                                    <FormattedMessage
                                                                        id="new_application.if_approved"
                                                                    />
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                        <StyledDivider />
                                                        <Grid
                                                            justifyContent="space-between"
                                                            container
                                                            spacing={calculatorSpace}
                                                        >
                                                            <Grid item>
                                                                <Typography type="title" color="inherit">
                                                                    {totalBalance} {" "}
                                                                    <FormattedMessage
                                                                        id="new_application.days"
                                                                    />
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item>
                                                                <Typography type="title" color="inherit">
                                                                    {taken} {" "}
                                                                    <FormattedMessage
                                                                        id="new_application.days"
                                                                    />
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item>
                                                                <Typography type="title" color="inherit">
                                                                    {ifApproved} {" "}
                                                                    <FormattedMessage
                                                                        id="new_application.days"
                                                                    />
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                        <BorderLinearProgress variant="determinate" value={progressValue} />
                                                    </Grid>
                                                    :
                                                    <Grid item xs={12}>
                                                        <Grid
                                                            justifyContent="flex-end"
                                                            container
                                                            spacing={calculatorSpace}
                                                        >
                                                            <Grid item>
                                                                <Typography type="title" color="inherit">
                                                                    <FormattedMessage
                                                                        id="new_application.taken"
                                                                    />
                                                            : {taken} {" "}
                                                                    <FormattedMessage
                                                                        id="new_application.days"
                                                                    />
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                }
                                            </>
                                        )}

                                        {/* Supporting Document DropzoneArea */}
                                        {showDropzone &&
                                            <Grid item xs={12}>
                                                {!showDropzoneValidator ?
                                                    <InputLabel id="document_label_id">
                                                        <FormattedMessage
                                                            id="new_application.supporting_document_optional"
                                                        />
                                                    </InputLabel>
                                                    :
                                                    <InputLabel id="document_label_id">
                                                        <FormattedMessage
                                                            id="new_application.supporting_document"
                                                        /> *</InputLabel>
                                                }
                                                <div className={classes.dropzoneDiv} style={disabled ? { pointerEvents: "none" } : {}}>
                                                    <DropzoneAreaValidator
                                                        value={values.attachment}
                                                        onDrop={handleUpload}
                                                        acceptedFiles={[
                                                            'image/*',
                                                            'image/heic',
                                                            'application/pdf',
                                                            'application/msword',
                                                            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                                            'application/vnd.ms-excel',
                                                            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                                                            'text/csv',
                                                            'application/vnd.ms-powerpoint',
                                                            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                                                            'application/rtf',
                                                            'text/plain'
                                                        ]}
                                                        filesLimit={100}
                                                        showPreviewsInDropzone={false}
                                                        showPreviews={false}
                                                        showFileNamesInPreview={false}
                                                        dropzoneClass={classes.dropzone}
                                                        dropzoneParagraphClass={classes.dropzoneParagraphClass}
                                                        maxFileSize={20971520}
                                                        validators={showDropzoneValidator ? ['required'] : []}
                                                        errorMessages={showDropzoneValidator ? errorMessage : []}
                                                        dropzoneText={intl.formatMessage({ id: 'new_application.dropzone_message' })}
                                                        previewText={intl.formatMessage({ id: 'new_application.preview' })}
                                                        showAlerts={['error', 'info']}
                                                    />
                                                </div>
                                            </Grid>
                                        }

                                        <Grid item xs={12}>
                                            <Collapse in={showFileUploaded}>
                                                <Alert severity="success" onClose={closeUploadedMessage}>
                                                    <Hidden smDown>
                                                        {uploadedFileName}
                                                    </Hidden>
                                                    <Hidden mdUp>
                                                        {(uploadedFileName).replace(/(.{30})..+/, "$1…")}
                                                    </Hidden>
                                                </Alert>
                                            </Collapse>
                                            <List>
                                                {values.attachment && values.attachment.map((file, idx) =>
                                                    <ListItem button key={idx} onClick={() => handleAttachmentClick(file.s3_url)} className={classes.editFile}>
                                                        <ListItemIcon>
                                                            <InsertDriveFileIcon />
                                                        </ListItemIcon>
                                                        <Hidden smDown>
                                                            <ListItemText primary={file.filename} />
                                                        </Hidden>
                                                        <Hidden mdUp>
                                                            <ListItemText primary={(file.filename).replace(/(.{30})..+/, "$1…")} />
                                                        </Hidden>
                                                        {showRemoveFile &&
                                                            <ListItemSecondaryAction>
                                                                <IconButton edge="end" aria-label="delete" onClick={() => handleAttachmentDelete(idx, file.file_id)}>
                                                                    <CancelIcon />
                                                                </IconButton>
                                                            </ListItemSecondaryAction>
                                                        }
                                                    </ListItem>
                                                )}
                                            </List>
                                        </Grid>

                                        {/* Leave Reason TextField */}
                                        {!showReasonValidator ?
                                            <Grid item xs={12}>
                                                <FormattedMessage id='new_application.reason_optional'>
                                                    {(message) =>
                                                        <TextField
                                                            disabled={disabled}
                                                            key="Edit Reason"
                                                            variant="outlined"
                                                            id="reason_id"
                                                            name="reason"
                                                            label={message}
                                                            value={values.reason}
                                                            onChange={handleChange}
                                                            multiline
                                                            rows={4}
                                                            fullWidth
                                                            inputProps={{
                                                                classes: {
                                                                    disabled: classes.disabled
                                                                }
                                                            }}
                                                        />
                                                    }
                                                </FormattedMessage>
                                            </Grid>
                                            :
                                            <Grid item xs={12}>
                                                <FormattedMessage id='new_application.reason'>
                                                    {(message) =>
                                                        <TextFieldValidator
                                                            disabled={disabled}
                                                            key="Edit Reason"
                                                            variant="outlined"
                                                            id="reason_id"
                                                            name="reason"
                                                            label={message + '*'}
                                                            value={values.reason}
                                                            onChange={handleChange}
                                                            multiline
                                                            rows={4}
                                                            fullWidth
                                                            inputProps={{
                                                                classes: {
                                                                    disabled: classes.disabled
                                                                }
                                                            }}
                                                            validators={['required']}
                                                            errorMessages={errorMessage}
                                                        />
                                                    }
                                                </FormattedMessage>
                                            </Grid>
                                        }
                                    </Grid>
                                    {open && (
                                        <Review
                                            handleClose={handleClose}
                                            open={open}
                                            mode={mode}
                                            applicationId={editApplicationId}
                                            employeeId={values.employeeId}
                                            employeeName={values.employeeName}
                                            typeId={values.typeId}
                                            typeName={typeName}
                                            startDate={values.startDate}
                                            startTime={values.startTime}
                                            untilDate={values.untilDate}
                                            endTime={values.endTime}
                                            period={taken}
                                            reason={values.reason}
                                            attachment={values.attachment}
                                            editAttachment={currentEditAttachment}
                                            status={values.status}
                                            staffDuty={staffDuty}
                                            isCompLeave={isCompLeave}
                                            takenCompLeave={takenCompLeave}
                                        />
                                    )}
                                </main>
                            }
                        </FormattedMessage>
                    </React.Fragment>
                    {approveOpen && (
                        <ConfirmBox 
                            approveMode={approveMode} 
                            leaveMode={window.global.LeaveApplication}
                            approveId={approveId} 
                            handleClose={handleConfirmClose} 
                            open={approveOpen} 
                            isApprove={action} 
                            editUpdatedAt={editUpdatedAt}
                            tabIndex={tabIndex}
                            isNewCompLeave={isNewCompLeave}
                        />
                    )}
                    {withDrawOpen && (
                        <WithDrawConfirm 
                            editApplicationId={editApplicationId} 
                            open={withDrawOpen} 
                            handleClose={handleConfirmClose} 
                            action={action} 
                            backToTable={backToTable} 
                            page={'Leave Application'}
                            isNewCompLeave={isNewCompLeave}
                            pageClose={pageClose}
                        />
                    )}
                </ValidatorForm>
                :
                <div className={classes.circularProgress}>
                    <CircularProgress />
                </div>
            }
            <ConfirmationBox
                handleCancel={handleConfirmationCancel}
                handleConfirm={handleConfirmationConfirm}
                open={confirmationDialog.open}
                msg={confirmationDialog.msg}
                title={confirmationDialog.title}
                uploadingMessage={confirmationDialog.uploadingMessage}
                error={confirmationDialog.error}
            />
        </MuiThemeProvider>
    );
}
